import PropTypes from 'prop-types'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import { useTranslation } from 'react-i18next'
import { HOPButtonGroup } from '@/shared/components/HOPComponents/HOPButtonGroup'
import RequiredLabel from '@/shared/components/RequiredLabel/RequiredLabel'
import { getLanguageOptions, isSupportedCountry } from '../config/languagePickerSupportedCountries'

const LanguagePicker = ({ country, onClickHandler, currentLanguage, disabled, languages = null, hidden = false }) => {
  const { t } = useTranslation()
  const LANGUAGE_OPTIONS = getLanguageOptions(t)
  const options = languages ?? (LANGUAGE_OPTIONS[country] || [])

  if (hidden || !isSupportedCountry(country)) return null

  return (
    <SDFormControl plainLabel label={<RequiredLabel label={t('additionalSales:language_picker.label')} />}>
      <HOPButtonGroup
        options={options}
        onClickHandler={onClickHandler}
        selectedValue={currentLanguage}
        size='compact'
        disabled={disabled}
      />
    </SDFormControl>
  )
}

LanguagePicker.propTypes = {
  country: PropTypes.string,
  onClickHandler: PropTypes.func,
  currentLanguage: PropTypes.string,
  disabled: PropTypes.bool,
  languages: PropTypes.arrayOf(PropTypes.object),
  hidden: PropTypes.bool,
}

export default LanguagePicker
